import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
import store from "../..";
const state = {
  courses: [],
  course: {},
  internalExternal: "",
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  pagination: {},
};
const getters = {
  courses: (state) => state.courses,
  courseGet: (state) => state.course,
  paginationGet: (state) => state.pagination,
};
const actions = {
  async getCourses({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    const result = await service.getFun(`courses?page=${page}`);
    if (result) {
      const pageRes = {
        currentPage: result.data.current_page,
        lastPage: result.data.last_page,
        itemsPerPage: 50,
        total: result.data.total,
      };
      commit("coursesListSet", result?.data.data);
      commit("setPagination", pageRes);
    }
  },

  getCourseById({ commit }, payload) {
    service.getFun(`courses/${payload}`).then(
      (obj) => {
        var result = obj.data;
        if (result.internalORexternal === 0) {
          commit("setInternalExternal", "external");
        } else {
          commit("setInternalExternal", "internal");
        }
        commit("CourseByIdMu", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  addCourse({ commit }, payload) {
    const data = service.deleteNullValues(payload);
    service
      .postFun(data, `courses`, null, {
        action: "getCourses",
        page: store.state.page.page,
      })
      .then(
        (result) => {
          if (result) {
            commit("addCourseStatus", result.success);
            toast("All Good");
          } else {
            commit("addCourseStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  editCourse({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `courses/${payload.id}`,
        null,
        {
          action: "getCourses",
          page: store.state.page.page,
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editCourseStatus", result.success);
            toast("All Good");
          } else {
            commit("editCourseStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async deleteCourse({ commit }, payload) {
    const result = await service.deleteFun(
      `courses/${payload.payload}`,

      {
        action: "getCourses",
        page: store.state.page.page,
      }
    );
    if (result) {
      commit("deleteCourseStatus", result.success);
      toast(result.message);
    } else {
      commit("deleteCourseStatus", false);
    }
  },
};
const mutations = {
  coursesListSet(state, courses) {
    state.courses = courses;
  },
  addCourseStatus(state, Status) {
    state.addStatus = Status;
  },
  CourseByIdMu(state, course) {
    state.course = course;
  },
  editCourseStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteCourseStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setInternalExternal(state, externalInternal) {
    state.internalExternal = externalInternal;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
